import React, { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import FullTestResultSummary from '../components/full_mock_test/attempt/FullTestResultSummary';

const FullTestResultPage = () => {
  const { attemptId } = useParams();
  const location = useLocation();
  const [result, setResult] = useState(location.state?.result || null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(!result); // Only load if no result was passed in state

  useEffect(() => {
    // If result is already available from navigation state, no need to fetch.
    if (result) return;

    const fetchResult = async () => {
      try {
        const token = localStorage.getItem('accessToken');
        if (!token) throw new Error('Authentication token not found.');
        
        const response = await fetch(`${process.env.REACT_APP_API_URL}/exam-attempts/${attemptId}/result`, {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch exam results.');
        }

        const data = await response.json();
        setResult(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (attemptId) {
      fetchResult();
    }
  }, [attemptId, result]);

  if (loading) {
    return (
        <div className="flex items-center justify-center h-screen bg-slate-50 dark:bg-slate-900">
            <div className="animate-spin rounded-full h-20 w-20 border-b-4 border-primary-blue"></div>
        </div>
    );
  }

  if (error) {
    return <div className="flex items-center justify-center h-screen bg-red-50 text-red-700">Error: {error}</div>;
  }

  return <FullTestResultSummary result={result} attemptId={attemptId} />;
};

export default FullTestResultPage;
